import { constants } from '@thecb/components';
import styled from 'styled-components';

const DateFilterContainer = styled.div`
  width: ${(props) => (props.fullWidth ? '100%' : '12rem')};
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
  input {
    // have ReactDate input match styles from FormInput CB component
    border: 1px solid
      ${(props) =>
        props.$hasError
          ? constants.colors.ERROR_COLOR
          : constants.colors.STORM_GREY};
    border-radius: 2px;
    height: 48px;
    width: 100%;
    padding: 1rem;
    min-width: 100px;
    margin: 0;
    box-sizing: border-box;
    position: relative;
    font-size: 1.1rem;
    font-family: Public Sans;
    line-height: 2rem;
    font-weight: 400;
    background-color: ${constants.colors.WHITE};
    color: ${constants.colors.MINESHAFT_GREY};
    box-shadow: none;
    -webkit-transition: background 0.3s ease;
    transition: background 0.3s ease;
    :focus {
      outline: 3px solid ${constants.colors.ROYAL_BLUE};
      outline-offset: 2px;
    }
  }
`;

export default DateFilterContainer;
